/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
// @ts-nocheck
import React, { Suspense, lazy } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
} from "react-router-dom";
import { TypeWriterLoaderVW } from "@vlinder-web/typewriter-loader-widget-react";
import { lazyWithRetry } from "./ComponentLoader";
const { isAuthenticated } = {};

// import LandingPage from '../pages/LandingPage';
// import EntertainmentPage from "../pages/Entertainment";
// import CollectiblesPage from "../pages/Collectibles";
// import SportsPage from "../pages/Sports";
// import ProductDetailPage from "../pages/ProductDetail";
// import WalletPage from "../pages/MyWallet";
// import TermsPage from "../pages/TermsandCondition";
// import PrivacyPage from "../pages/PrivacyPolicy";
// import ScrollToTop from "./ScrollToTop";
// import MyProfilePage from "../pages/MyProfile";
// import MyTransactionPage from '../pages/MyTransactions';
// import MyProductDetailpage from '../pages/MyProductDetail';
// import UserProductsPage from '../pages/UserProducts';
// import ProductTransactionDetailPage from '../pages/ProductTransactionDetail';
// import Login from '../pages/Login';
// import LogoutPage from '../pages/Logout';

const LandingPage = lazyWithRetry(() => import("../pages/LandingPage"));
const EntertainmentPage = lazyWithRetry(() => import("../pages/Entertainment"));
const CollectiblesPage = lazyWithRetry(() => import("../pages/Collectibles"));
const SportsPage = lazyWithRetry(() => import("../pages/Sports"));
const ProductDetailPage = lazyWithRetry(() => import("../pages/ProductDetail"));
const WalletPage = lazyWithRetry(() => import("../pages/MyWallet"));

const TermsPage = lazyWithRetry(() => import("../pages/TermsandCondition"));
const PrivacyPage = lazyWithRetry(() => import("../pages/PrivacyPolicy"));
const ScrollToTop = lazyWithRetry(() => import("./ScrollToTop"));
const MyProfilePage = lazyWithRetry(() => import("../pages/MyProfile"));
const MyTransactionPage = lazyWithRetry(
    () => import("../pages/MyTransactions")
);
const MyProductDetailpage = lazyWithRetry(
    () => import("../pages/MyProductDetail")
);
const UserProfilePage = lazyWithRetry(() => import("../pages/UserProducts"));
const ProductTransactionDetailPage = lazyWithRetry(
    () => import("../pages/ProductTransactionDetail")
);
const Login = lazyWithRetry(() => import("../pages/login"));
const LogoutPage = lazyWithRetry(() => import("../pages/Logout"));
const TragProvenancePage = lazyWithRetry(
    () => import("../pages/TragProvenance")
);
const Category4Page = lazyWithRetry(() => import("../pages/Category4"));
const Category5Page = lazyWithRetry(() => import("../pages/Category5"));
const DZIPage = lazyWithRetry(() => import("../pages/DZI"));

const RouterConfig = (props) => (
    <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route exact path="/collection/diageo-india" component={EntertainmentPage} />
        <Route exact path="/collection/rc-rcb" component={SportsPage} />
        <Route exact path="/collection/the-true-bonds-of-yaari" component={CollectiblesPage} />
        <Route exact path="/collection/johnnie-walker-story" component={Category4Page} />
        <Route exact path="/collection/epitome-reserve" component={Category5Page} />
        <Route exact path="/collection/all" component={DZIPage} />
        <Route path="/assets/:address/:id" component={ProductDetailPage} />
        <Route exact path="/terms" component={TermsPage} />
        <Route exact path="/privacy" component={PrivacyPage} />
        <Route exact path="/my-wallet" component={WalletPage} />
        <Route exact path="/my-profile" component={MyProfilePage} />
        <Route exact path="/my-transactions" component={MyTransactionPage} />
        <Route
            exact
            path="/my-assets/:address/:id"
            component={MyProductDetailpage}
        />
        <Route exact path="/login" component={Login} />
        <Route exact path="/logout" component={LogoutPage} />
        <Route
            exact
            path="/tx/:address/:id"
            component={ProductTransactionDetailPage}
        />
        <Route
            exact
            path="/provenance/:id(.*)"
            component={TragProvenancePage}
        />
        <Route exact path="/:id(.*)" component={UserProfilePage} />
    </Switch>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `/login`,
                    }}
                />
            )
        }
    />
);

function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={(props) => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            )}
        />
    );
}

export const AppNavigator = (): JSX.Element => {
    return (
        <Router>
            <Suspense fallback={<TypeWriterLoaderVW />}>
                <ScrollToTop />
                <RouterConfig />
            </Suspense>
        </Router>
    );
};
